import { Route, Routes } from "react-router-dom";
import { CranePage } from "./CranePage";
import { CraneProvider } from "./CraneContext";

type Props = {};
const CatalogCrane = (props: Props) => {
  return (
    <CraneProvider>
      <Routes>
        <Route index element={<CranePage />}></Route>
        <Route path=":craneId" element={<CranePage />}></Route>
      </Routes>
    </CraneProvider>
  );
};
export default CatalogCrane;
